export default "__VITE_ASSET__D4lb7Tr2__"